module.exports = "//img1.rrcimg.com/_next/static/src/assets/cs_lDANG.png";